import { CustomSelector } from "../ui/components/CustomSelector";

export class SpeakerOptions extends CustomSelector {
    init() {
        super.init();

        this.selectOptions?.addClass("d-none");

        this.on("click", (e) => {
            if (!this.element.contains(e.target)) {
                this.closeOptions();
            }
        });
    }

    getSelectOptions() {
        return this.selectOptions?.el().querySelectorAll(
            ".language-choice__custom-select__select-option"
        );
    }

    toggleSelect(e) {
        // На десктопе предотвращаем открытие offcanvas и показываем dropdown
        if (window.innerWidth >= 768) {
            e.preventDefault();
            e.stopPropagation();
            
            document
                .querySelectorAll(".language-choice__custom-select__select-options")
                .forEach((el) => {
                    if (el !== this.selectOptions.el()) {
                        el.classList.add("d-none");
                    }
                });

            this.selectOptions.el().classList.toggle("d-none");
        }
        // На мобильных Bootstrap сам откроет offcanvas через data-атрибуты
    }

    closeOptions() {
        if (
            this.selectOptions &&
            !this.selectOptions.el().classList.contains("d-none")
        ) {
            this.selectOptions.el().classList.add("d-none");
        }
    }

    handleOptionSelect(e, option) {
        e.stopPropagation();

        const text = option.textContent.trim();
        const value = option.getAttribute("data-value");

        this.selectSelected.selectedText.el().textContent = text;
        this.emitOptionSelected(value);
        this.closeOptions();
    }

    handleMobileOptionSelect(e, optionComponent) {
        e.stopPropagation();

        const text = optionComponent.textContent.trim();
        const value = optionComponent.getAttribute("data-value");

        this.selectSelected.selectedText.el().textContent = text;
        this.emitOptionSelected(value);
    }

    emitOptionSelected(value) {
        this.emit("option-selected", { value: parseInt(value) });
        this.element.dispatchEvent(
            new CustomEvent("option-selected", {
                detail: { value: parseInt(value) },
                bubbles: true,
            })
        );
    }

    disable() {
        this.customSelect.addClass('disabled');
    }

    enable() {
        this.customSelect.removeClass('disabled');
    }
}
